export default {
   info: (daysAhead: number) => `
      [[ p ]]
         Kindergeburtstage sind ganzjährig an jedem Wochentag buchbar, in der Ferienzeit nur samstags oder sonntags
         (naturpädagogische Angebote nur von April bis Oktober). Bitte buchen Sie rechtzeitig
         (spätestens ${daysAhead} ${daysAhead === 1 ? 'Tag' : 'Tage'})
         vor dem gewünschten Termin.
      [[ /p ]]`,
   intro: `
      [[ p ]]
         Bitten Informieren Sie sich vor Ihrer Buchung auf unserer
         [[ {"a":{"href":"https://www.jugendfarm-er.de", "title":"Alle Informationen zu Kindergeburtstagen lesen", "target":"_blank"}} ]]Webseite[[ /a ]] 
         über unser Kindergeburstagsangebot.
      [[ /p ]]`,
   footer: '[[ {"a":{"href":"https://jugendfarm-er.de", "title":"Impressum und Datenschutz ansehen", "target":"_blank"}} ]]Impressum / Datenschutz[[ /a ]]',
   approvals: [
      'Ich ermächtige die Jugendfarm e.V. eine einmalige Zahlung von meinem Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die von der Jugendfarm e.V. auf mein Konto gezogene Lastschrift einzulösen.',
      'Ich bin darüber informiert, dass die Aufsichtspflicht während des Kindergeburtstags bei den Eltern liegt.',
      'Ich werde an dem Geburtstag möglichst wenig Plastik (z. B. Verpackungen, Einweg-Deko und Wegwerfartikeln) verwenden.',
      'Ich habe die besonderen [[ {"a":{"href":"https://www.jugendfarm-er.de","title":"Nutzungsbedingungen der Jugendfarm Erlangen als PDF ansehen","target":"_blank"}} ]]Hinweise und Nutzungsbedingungen[[ /a ]] der Jugendfarm gelesen und erkenne sie an.',
      'Ich stimme der Verarbeitung und Speicherung meiner Daten im Rahmen des [[ {"a":{"href":"https://www.jugendfarm-er.de","title":"Datenschutz der Jugendfarm Erlangen als PDF ansehen","target":"_blank"}} ]]Datenschutzes[[ /a ]] zu.'
   ]
};